import React from 'react'
import './ProgramSchedule.css'
import pdf1 from "../../assets/docs/IITCEE2024_Template.pptx"
import img1 from "../../assets/images/schedule1.jpg"
import img2 from "../../assets/images/schedule2.jpg"
import pdf2 from "../../assets/docs/program schedule for authors.pdf"
const ProgramSchedule = () => {
    return (
        <div className='Schedule' style={{ heigh: "fit-content" }}>
            <h1 className="ch">Program Schedule</h1>
            <div style={{ display: 'flex', flexDirection: 'column', gap: "2rem" }}>
                <div className='flex flex-col'>
                    <h2 className="tite"><i className="fa-solid fa-hand-point-right"></i>Presentation template for ICIITCEE 2024 papers</h2>
                    <a href={pdf1} download="Presentation template.pptx" rel="noreferrer"
                        className="smalltite"><button className="download-btn">Download template</button></a>
                </div>
            </div>
            <div className='lappy_version flex flex-col justify-center gap-8'>
                <img className='www' src={img1} alt='schedule1' />
                <img className='www' src={img2} alt='schedule1' />
            </div>
            <div className='mobile_version' style={{ display: 'flex', flexDirection: 'column', gap: "2rem" }}>
                <div className='mobile_version flex flex-col'>
                    <h2 className="tite"><i className="fa-solid fa-hand-point-right"></i>Program schedule for authors </h2>
                    <a href={pdf2} download="Program_shedule.pdf" rel="noreferrer"
                        className="smalltite"><button className="download-btn">Download template</button></a>
                </div>
            </div>
        </div>
    )
}

export default ProgramSchedule